import swal from "sweetalert";
import { https } from "../http";
import store from "../store";
import {
  setStaff,
  setAttendanceStaff,
  setLoading,
  setAddStaffLoading,
  setAllStaff,
  setStaffCounts,
  setFacilityClients,
  setFacilityClientsCount,
  setloadingFacilityClients,
  setSingleStaff,
} from "../store/reducers/staff";
import { showError } from "../utils/index";

// GET
const getAllStaff = async (page, showLoading = true, selectedTab, search) => {
  try {
    const strUrl = `/staff/${page}?search=${search}`;
    let baseURL =
      selectedTab != undefined ? `${strUrl}&status=${selectedTab}` : strUrl;
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(baseURL);
    if (response?.status === 200) {
      store.dispatch(setStaff(response?.data?.staffs));
      store.dispatch(setStaffCounts(response?.data?.count));
      store.dispatch(setAllStaff(response?.data?.allStaff));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// GET
const getAllStaffSkypoint = async (page, showLoading = true, selectedTab, search = '') => {
  try {
    const strUrl = `/staff/skypoint/${page}?search=${search}`;
    let baseURL =
      selectedTab != undefined ? `${strUrl}&status=${selectedTab}` : strUrl;
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(baseURL);
    if (response?.status === 200) {
      store.dispatch(setStaff(response?.data?.staffs));
      store.dispatch(setStaffCounts(response?.data?.count));
      store.dispatch(setAllStaff(response?.data?.allStaff));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// GET — for a staff picker: active staff whose name matches `search`, one page (10, the owner
// first) and how many match in all. Returned rather than stored, so a picker never replaces
// the staff list page's rows. The owner isn't in the server's count; it's added here so
// "N of M" counts the same rows.
const searchStaffSkypoint = async (search = "") => {
  try {
    const response = await https().get(
      `/staff/skypoint/1?status=true&search=${encodeURIComponent(search)}`
    );
    if (response?.status === 200) {
      const staffs = response?.data?.staffs || [];
      const owners = staffs.filter((s) => s?.isOwner).length;
      return { staffs, count: (response?.data?.count || 0) + owners };
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
  return { staffs: [], count: 0 };
};

// GET SINGLE STAFF BY ID
const getStaffById = async (id) => {
  try {
    let baseURL = `/staff/staff/${id}`;
    let response = await https().get(baseURL);
    if (response?.status === 200) {
      store.dispatch(setSingleStaff(response?.data?.staff));
      return response?.data?.staff;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// GET SINGLE STAFF BY ID
const getStaffByIdSkypoint = async (id) => {
  try {
    let baseURL = `/staff/skypoint/staff/${id}`;
    let response = await https().get(baseURL);
    if (response?.status === 200) {
      store.dispatch(setSingleStaff(response?.data?.staff));
      return response?.data?.staff;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getAllAttendenceStaff = async (page, range, search, singleId) => {
  try {
    let baseURL = `/staff/manage-attendance`;
    let response = await https().post(baseURL, {
      page,
      range,
      search,
      singleId,
    });
    if (response?.status === 200) {
      store.dispatch(setAttendanceStaff(response?.data?.staffs));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getAllAttendenceOfSingleStaff = async (id, range) => {
  try {
    let baseURL = `/staff/manage-attendance`;

    let response = await https().post(baseURL, { id, range });
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const updateAttendenceStaff = async (payload) => {
  try {
    let baseURL = `/staff/update-attendance`;
    let response = await https().post(baseURL, payload);
    if (response?.status === 200) {
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const deleteAttendanceStaff = async (id) => {
  try {
    let response = await https().post("/staff/delete-attendance", { id });
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getFacilityClients = async (
  facilityIds = [],
  staffId,
  currentPage,
  search,
  showLoading = true
) => {
  const dispatch = store.dispatch;
  let strUrl = "/client/facility-clients";

  try {
    if (staffId) {
      strUrl += `?staffId=${staffId}`;
    }
    if (showLoading) {
      dispatch(setloadingFacilityClients(true));
    }
    const response = await https().post(strUrl, {
      facilityIds,
      currentPage,
      search,
    });
    if (response?.status === 200) {
      dispatch(setFacilityClients(response.data.result));
      dispatch(setFacilityClientsCount(response.data.count));
    }
  } catch (error) {
    showError(
      error?.response?.data?.message || error.message,
      error?.response?.status
    );
  } finally {
    if (showLoading) {
      dispatch(setloadingFacilityClients(false));
    }
  }
};

const uploadStaffProfile = async (data) => {
  try {
    let response = await https().post(`/staff/profilephoto`, data);

    if (response?.status === 200) {
      //getProfile();
      return response?.data;
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    showError(_error, error?.response?.status);
    return false;
  }
};

const updateAssignedStaffPatients = async (data) => {
  try {
    // store.dispatch(ssetLoading(true));
    let response = await https().post("/client/assign-staff-clients", data);

    if (response?.status === 200) {
      // swal({
      //   title: `Client Assigned Successfully`,
      //   text: "Client assigned to this Staff successfully",
      //   icon: "success",
      //   dangerMode: false,
      // });
    }
  } catch (error) {
    // store.dispatch(setLoading(false));
    showError(
      error?.response?.data?.message || error.message,
      error?.response?.status
    );
  }
};

// // GET Facility Clients
// const getFacilityClients = async (facilityIds = [], showLoading = true) => {
//   try {
//     // if (!facilityIds || facilityIds.length === 0) throw new Error("Facility ID is required");

//     // const query = facilityIds?.map((id) => `facilityId=${id}`).join("&");
//     // const query = `facilityId=${facilityIds.join(",")}`;

//     const strUrl = `/facility-clients`;
//     if (showLoading) store.dispatch(setLoading(true));

//     let response = await https().get(strUrl, facilityIds);
//     if (response?.status === 200) {
//       store.dispatch(setFacilityClients(response?.data));
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(
//       error?.response?.data?.message || error.message,
//       error?.response?.status
//     );
//   }
// };

// POST
// Function to add a staff member
const addStaff = async (data, selectedTab) => {
  try {
    // Dispatch an action to set the loading state to true
    store.dispatch(setAddStaffLoading(true));
    let response = await https().post("/staff", data);

    if (response?.status === 200) {
      swal({
        title: `Verify Your Email`,
        text: "Email verification link sent successfully",
        icon: "success",
        dangerMode: false,
      });
      getAllStaff(1, true, selectedTab, "");
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));

    let string = error?.response?.data?.message;
    if (string?.includes("duplicate") && string.includes("email"))
      return showError("Staff with this email already exists");
    if (string?.includes("duplicate") && string.includes("name"))
      return showError("Staff with this name already exists");
    else showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// Function to add a staff member
// Pass `restore: true` in `data` to reactivate a staff member this contractor
// removed earlier instead of creating a new record.
const addStaffSkypoint = async (data, selectedTab) => {
  try {
    // Dispatch an action to set the loading state to true
    store.dispatch(setAddStaffLoading(true));
    let response = await https().post("/staff/skypoint", data);

    if (response?.status === 200) {
      swal({
        title: response?.data?.restored ? `Staff Restored` : `Verify Your Email`,
        text: response?.data?.restored
          ? "Their account has been restored and a new signup email was sent."
          : "Email verification link sent successfully",
        icon: "success",
        dangerMode: false,
      });
      getAllStaffSkypoint(1, true, selectedTab, "");
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));

    // The email belongs to a staff member this contractor removed earlier. Hand the
    // case back to the caller so it can offer a restore instead of showing an error.
    if (error?.response?.data?.code === "STAFF_PREVIOUSLY_REMOVED") {
      return { previouslyRemoved: true, ...error.response.data };
    }

    // The server's message as it is: it says where the email is already used (this
    // contractor's staff, another contractor's, or another Skypoint account). Only a raw
    // database duplicate-key error is put in words.
    let string = error?.response?.data?.message;
    if (string?.includes("E11000") && string.includes("email"))
      return showError("Staff with this email already exists");
    if (string?.includes("E11000") && string.includes("name"))
      return showError("Staff with this name already exists");
    showError(string, error?.response?.status);
    return false;
  }
};

// Re-issues the signup/verification email. Any link sent earlier stops working.
const resendStaffInviteSkypoint = async (staffId) => {
  try {
    let response = await https().post("/staff/skypoint/resend-invite", {
      staffId,
    });
    if (response?.status === 200) {
      swal({
        title: "Invitation Sent",
        text: response?.data?.message || "A new signup email has been sent.",
        icon: "success",
        dangerMode: false,
      });
      return true;
    }
    return false;
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// PUT

const editStaff = async (data, showLoading = true, selectedTab) => {
  try {
    store.dispatch(setAddStaffLoading(true));
    let response = await https().put(`/staff`, data);
    if (response?.status === 200) {
      getAllStaff(1, true, selectedTab, "");
      return true;
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const editStaffSkypoint = async (data, showLoading = true, selectedTab) => {
  try {
    store.dispatch(setAddStaffLoading(true));
    let response = await https().put(`/staff/skypoint`, data);
    if (response?.status === 200) {
      getAllStaffSkypoint(1, true, selectedTab, "");
      return true;
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// update staff status

const updateStaffStatus = async (data, showLoading = true, selectedTab) => {
  const { id, active } = data;
  try {
    store.dispatch(setAddStaffLoading(true));
    let response = await https().post(`/staff/update-status/${id}`, {
      status: active,
    });
    if (response?.status === 200) {
      getAllStaff(1, true, selectedTab, "");
      return true;
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


// update staff status skypoint

const updateStaffStatusSkypoint = async (data, showLoading = true, selectedTab) => {
  const { id, active } = data;
  try {
    store.dispatch(setAddStaffLoading(true));
    let response = await https().post(`/staff/skypoint/update-status/${id}`, {
      status: active,
    });
    if (response?.status === 200) {
      getAllStaffSkypoint(1, true, selectedTab, "");
      return true;
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// DELETE

const removeStaff = async (id, callback, selectedTab) => {
  try {
    store.dispatch(setAddStaffLoading(true));
    let response = await https().delete(`/staff/${id}`);
    if (response?.status === 200) {
      getAllStaff(1, true, selectedTab, "");
      callback?.();
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const removeStaffSkypoint = async (id, callback, selectedTab) => {
  try {
    store.dispatch(setAddStaffLoading(true));
    let response = await https().delete(`/staff/${id}`);
    if (response?.status === 200) {
      getAllStaffSkypoint(1, true, selectedTab, "");
      callback?.();
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  addStaffSkypoint,
  getAllStaff,
  getStaffById,
  getAllAttendenceStaff,
  addStaff,
  removeStaff,
  removeStaffSkypoint,
  editStaff,
  updateStaffStatus,
  getFacilityClients,
  updateAssignedStaffPatients,
  uploadStaffProfile,
  updateAttendenceStaff,
  deleteAttendanceStaff,
  getAllAttendenceOfSingleStaff,
  getAllStaffSkypoint,
  searchStaffSkypoint,
  getStaffByIdSkypoint,
  editStaffSkypoint,
  updateStaffStatusSkypoint,
  resendStaffInviteSkypoint
};
